import { Link } from "react-router-dom";
import styled, { css } from "styled-components";

const breakpoint = "1060px";

export const HeaderContainer = styled.header`
  transition: all 0.2s linear;
  display: flex;
  align-items: center;
  border-bottom: 1px solid var(--pink);
  min-height: var(--headerHeight);
  @media (max-width: 900px) {
    min-height: calc((var(--headerHeight) / 2));
  }
  width: auto;
  z-index: 1000;
  background-color: var(--white);
  left: 0px;
  right: 0px;
  top: 0px;
`;

export const LogoContainer = styled.img`
  cursor: pointer;
  width: calc(var(--headerHeight) + 3px);
  height: calc(var(--headerHeight) + 3px);
`;
